import { apiFetch } from '../api-client';

export interface AccountingPeriod {
  id: string;
  year: number;
  month: number | null;
  status: 'OPEN' | 'LOCKED';
  lockedAt: string | null;
  lockedBy: string | null;
  unlockedAt: string | null;
  unlockedBy: string | null;
  unlockReason: string | null;
  createdAt: string;
}
export interface PeriodConfig {
  reportPeriodDefault: string;
  fiscalYearStart: string;
  accountingBasis: string;
  autoLockNextMonth: boolean;
  autoLockDay: number;
}
export interface CreateYearResult {
  year: number;
  created: number;
  skipped: number;
  message: string;
}
export const accountingPeriodsApi = {
  list: () => apiFetch<{ periods: AccountingPeriod[]; config: PeriodConfig | null }>('/api/accounting-periods'),
  updateConfig: (body: Partial<PeriodConfig>) =>
    apiFetch<PeriodConfig>('/api/accounting-periods/config', { method: 'PATCH', body: JSON.stringify(body) }),
  createYear: (year: number) =>
    apiFetch<CreateYearResult>('/api/accounting-periods/create-year', { method: 'POST', body: JSON.stringify({ year }) }),
  lock: (year: number, month: number) =>
    apiFetch<AccountingPeriod>(`/api/accounting-periods/${year}/${month}/lock`, { method: 'POST' }),
  unlock: (year: number, month: number, reason: string) =>
    apiFetch<AccountingPeriod>(`/api/accounting-periods/${year}/${month}/unlock`, { method: 'POST', body: JSON.stringify({ reason }) }),
};
